import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

const baseStyles = () => css`
  margin: 0 auto;
`;

const inactiveStyles = ({ inactive }) =>
  inactive &&
  css`
    opacity: 0.4;
  `;

const Container = styled('div')(baseStyles, inactiveStyles);

const GameItem = ({ children, inactive }) => <Container inactive={inactive}>{children}</Container>;

GameItem.propTypes = {
  children: PropTypes.node,
  inactive: PropTypes.bool,
};

export default GameItem;
